import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Cathy extends Lit3formBlock {
  static get characterName() {
    return 'cathy';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid cathy-layout">
          <div class="cathy-content">
            <div class="text-column">
              <div class="title-desc">
                ${this.headerText
                  ? html`
                      <h2 class="title">${unsafeHTML(this.headerText)}</h2>
                    `
                  : html``}
                ${this.descriptionText
                  ? html`
                      <p class="description">
                        ${unsafeHTML(this.descriptionText)}
                      </p>
                    `
                  : html``}
              </div>
              ${this.ctaHTML}
            </div>
            ${this.imageHTML}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get imageHTML() {
    const card = this.driverCard;
    if (!card || !card.src) {
      return html`
        <div class="image-column">
          <div class="image-holder"></div>
        </div>
      `;
    }
    return html`
      <div class="image-column">
        <div class="image-holder">
          <img src=${this.imageUrl(card.src)} alt="" />
        </div>
      </div>
    `;
  }

  get ctaHTML() {
    const cta = this.ctaData;
    if (!cta || !cta.text) return html``;
    return html`
      <cta-button
        class="cta"
        cta-data=${JSON.stringify({ ...cta, fullWidth: false })}
        cta-type="primary"
        .ctaAnalyticsData=${analyticsCtaDataObject(cta, this.headerText)}
      ></cta-button>
    `;
  }

  imageUrl(src) {
    return this.imagebossUrl(src, 900);
  }

  get driverCard() {
    return this.content.driver_card;
  }

  get ctaData() {
    return this.content.call_to_action;
  }
}
Cathy.defineElement();
